module.exports = __webpack_public_path__ + "static/media/cover_lunch.88f2997d.png";